import { Color } from "../enums/Color";

const tag = {
    display: "inline-block",
    fontSize: "12px",
    fontWeight: "bold",
    padding: "3px 10px",
    borderRadius: "12px",
    marginBottom: "4px"
};

export const videoLessonListPage = {
    mobile: {
        margin: "16px 4%",
        heading: {
            textAlign: "center" as "center",
            margin: "0 0 12px 0"
        },
        toolbar: {
            display: "flex",
            flexDirection: "row" as "row",
            flexWrap: "wrap" as "wrap",
            // Top-aligned because the shared Select keeps bottom padding under its label (it bridges the hover gap to the dropdown)
            alignItems: "flex-start" as "flex-start",
            gap: "12px"
        },
        statusButton: {
            height: "40px",
            padding: "0 16px",
            background: "transparent",
            color: Color.ChathamsBlue,
            fontSize: "15px",
            fontWeight: "bold",
            border: "2px solid " + Color.Green,
            borderRadius: "8px",
            cursor: "pointer",
            active: {
                background: Color.Green,
                color: Color.White
            }
        },
        // Label box matches the status buttons: 40px tall, 8px radius, 15px text
        teacherSelect: {
            wrapper: {
                width: "260px",
                marginTop: "0",
                marginLeft: "unset"
            },
            labelWrapper: {
                height: "40px",
                padding: "0 12px",
                boxSizing: "border-box" as "border-box",
                alignItems: "center",
                borderRadius: "8px"
            },
            label: {
                fontSize: "15px"
            },
            hover: {
                width: "250px",
                height: "320px",
                left: "unset",
                padding: "5px"
            }
        },
        // Pushes itself and New Lesson to the right end of the toolbar
        payoutsButton: {
            height: "40px",
            padding: "0 24px",
            background: Color.White,
            color: Color.ChathamsBlue,
            fontSize: "15px",
            fontWeight: "bold",
            border: "2px solid " + Color.ChathamsBlue,
            borderRadius: "8px",
            marginLeft: "auto",
            cursor: "pointer"
        },
        newButton: {
            height: "40px",
            padding: "0 24px",
            background: Color.ChathamsBlue,
            color: Color.White,
            fontSize: "15px",
            fontWeight: "bold",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer"
        },
        table: {
            width: "100%",
            margin: "20px 0 0 0",
            border: "2px solid " + Color.Green,
            borderCollapse: "collapse" as "collapse",
            // Fixed layout: the fixed-width columns keep their size, and Lesson and Teacher & Subject share the rest
            tableLayout: "fixed" as "fixed",
            fontSize: "14px",
            header: {
                height: "44px",
                backgroundColor: Color.Green,
                color: Color.White
            },
            tr: {
                border: "2px solid " + Color.Green,
                textAlign: "center" as "center",
                verticalAlign: "top" as "top"
            },
            idColumn: { width: "60px" },
            imageColumn: { width: "120px" },
            lessonColumn: {},
            teacherColumn: {},
            contentColumn: { width: "160px" },
            statusColumn: { width: "220px" },
            actionColumn: { width: "130px" },
            leftCell: {
                textAlign: "left" as "left",
                padding: "10px"
            },
            image: {
                height: "80px",
                width: "80px",
                objectFit: "cover" as "cover",
                borderRadius: "8px",
                margin: "10px 0"
            },
            primaryText: {
                fontWeight: "bold",
                marginBottom: "4px"
            },
            subjectText: {
                marginTop: "6px",
                color: Color.ChathamsBlue
            },
            mutedText: {
                fontSize: "12px",
                color: Color.SharpAsh
            },
            okText: {
                color: Color.Viridian,
                fontWeight: "bold"
            },
            warningText: {
                color: Color.HarvestGold,
                fontWeight: "bold"
            },
            newTag: {
                ...tag,
                color: Color.ChathamsBlue,
                backgroundColor: Color.AliceBlue
            },
            editedTag: {
                ...tag,
                color: Color.HarvestGold,
                backgroundColor: Color.OldLace
            },
            approvedTag: {
                ...tag,
                color: Color.Viridian,
                backgroundColor: Color.Nyanza
            },
            actionWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "flex-start" as "flex-start",
                gap: "8px",
                padding: "10px 16px"
            },
            // Icon and label stay on one line
            action: {
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap" as "nowrap",
                cursor: "pointer",
                locked: {
                    opacity: 0.4
                }
            },
            icon: {
                height: "12px",
                width: "12px",
                marginRight: "8px",
                edit: { fill: Color.LemonCurry },
                approve: { fill: Color.Viridian },
                delete: { fill: Color.Red }
            }
        },
        deleteDialog: {
            backdrop: {
                backgroundColor: Color.Black,
                opacity: 0.15,
                position: "fixed" as "fixed",
                left: "0",
                right: "0",
                bottom: "0",
                top: "0"
            },
            content: {
                background: Color.White,
                position: "fixed" as "fixed",
                top: "31%",
                left: "5%",
                width: "80%",
                padding: "20px 5%",
                borderRadius: "10px",
                zIndex: "4",
                boxShadow: "1px 0px 7px rgba(0,0,0,0.5)"
            },
            text: {
                fontSize: "20px",
                textAlign: "center" as "center"
            },
            button: {
                height: "36px",
                width: "142px",
                background: Color.Red,
                color: Color.White,
                border: "none",
                borderRadius: "5px",
                fontWeight: "bold",
                float: "right" as "right",
                margin: "24px 0 0 0",
                cursor: "pointer"
            }
        }
    },
    desktop: {
        deleteDialog: {
            content: {
                left: "31%",
                width: "34%",
                padding: "20px"
            }
        }
    }
}
